import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('Company', {
    error: (
        <FormattedMessage
            id='front-app/Company/Notification/Error:title'
            defaultMessage='Company Error'
        />
    ),
    warning: (
        <FormattedMessage
            id='front-app/Company/Notification/Warning:title'
            defaultMessage='Company Warning'
        />
    ),
    info: (
        <FormattedMessage
            id='front-app/Company/Notification/Info:title'
            defaultMessage='Company Info'
        />
    ),
    success: (
        <FormattedMessage
            id='front-app/Company/Notification/Info:title'
            defaultMessage='Company Info'
        />
    ),
});

export const companyNotifications = {
    createdSuccessfully: notification.success(appNotification.texts.createdSuccessfully),
    updatedSuccessfully: notification.success(appNotification.texts.updatedSuccessfully),
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
